enum GatewayPagamentoProvider {
    PagSeguro = 1,
    Getnet = 2,
}

export default GatewayPagamentoProvider;
